import {createContext} from 'react';

export const AvailContext = createContext({});